export const FrameTypes = {
    TEXT: 'T',
    DATA: 'D',
    CUSTOM: 'C',
    SECTION: 'S',
    PAGE: 'P'
}
